import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import {AdapterDateFns} from "@mui/x-date-pickers/AdapterDateFns";
import {es} from "date-fns/locale";
import {DatePicker, DatePickerProps} from "@mui/x-date-pickers";
import {Control, Controller} from "react-hook-form";
import React, { ReactNode } from "react";

interface ControlledDatePickerProps extends DatePickerProps<any> {
    control: Control<any>,
    name: string,
    disabled?: boolean,
    label?: ReactNode | null,
    format?: 'MM/yyyy' | 'dd/MM/yyyy',
    helperText?: string
}

export const ControlledDatePicker = ({
                                         control, name,
                                         ...props
                                     }: ControlledDatePickerProps
) => {
    return (
        <Controller
            control={control}
            name={name || ''}
            render={({ field: { onChange, value }, fieldState: { error }  }) => (
                <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={es}>
                    <DatePicker
                        {...props}
                        value={value}
                        onChange={onChange}
                        format={props.format || 'dd/MM/yyyy'}
                        slotProps={{
                            textField: {
                                size: 'small',
                                helperText: error ? error.message : props.helperText || '',
                                error: !!error
                            }}}
                    />
                </LocalizationProvider>
            )}
        />
    )
}